import React, { useState } from 'react';
import { TongueTable } from './components/TongueTable';
export function App() {
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="max-w-7xl mx-auto p-6 min-h-screen" data-id="element-0">
      <h2 className="text-2xl font-bold mb-4" data-id="element-1">
        Tongue Diagnosis Interactive Table (TCM)
      </h2>
      <input type="text" placeholder="Type to filter: e.g., Heat, Swollen, Cold ..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="mb-4 p-2 border border-gray-300 rounded w-full md:w-1/2 text-base" data-id="element-2" />
      <TongueTable searchQuery={searchQuery} data-id="element-3" />
    </div>;
}